import { apiKeyHolder } from "@/utils/apikey";
import { theme } from "@/utils/theme";
import { Component, h, Host, Prop } from "@stencil/core";
import { customParametersHolder } from "@/utils/customparameters";

@Component({
  tag: "pace-carboncalculator",
  styleUrl: "pace-carboncalculator.scss",
  shadow: true,
  assetsDirs: ["../assets"],
})
export class PaceCarboncalculator {
  /**
   * Current API key
   */
  @Prop() apikey: string;
  /**
   * Overrides default font and color palette
   */
  @Prop() theme = "{}";
  /**
   * Displays equivalent metrics (true by default)
   */
  @Prop() showEquivalents = true;
  /**
   * Applies IATA Load Factor to emission calculations (false by default)
   */
  @Prop() applyLoadFactor = false;
  /**
   * Shows widget on landscape mode (false by default)
   */
  @Prop() landscapeMode = false;
  /**
   * Predefines container width. If not defined it will set a container of 500px by default
   */
  @Prop() containerWidth = "none";
  /**
   * Overrides footer class with a modifier that can point to certain product logos
   */
  @Prop() logoMod = "";

  componentWillLoad() {
    theme.setTheme(JSON.parse(this.theme));
    theme.setLandscapeMode(this.landscapeMode);

    if (!this.apikey) {
      apiKeyHolder.setApiKey("");
      return;
    }
    apiKeyHolder.setApiKey(this.apikey);
    customParametersHolder.setLoadFactorApplicable(this.applyLoadFactor);
  }

  render() {
    return (
      <Host style={theme.getHostStyle(this.containerWidth)}>
        <div class="pace-widget-container">
          <section>
            <pace-message-box style={theme.getSubHostStyle()} />
          </section>
          <div class={theme.getSectionContainerClass()}>
            <section class={theme.getSectionClass(3)}>
              <pace-search-form style={theme.getSubHostStyle()} />
            </section>
            <section class={theme.getSectionClass(5)}>
              <pace-result-box
                class={theme.getSectionContainerClass()}
                style={theme.getSubHostStyle()}
                showEquivalents={this.showEquivalents}
              />
            </section>
          </div>
        </div>
        <footer class={this.logoMod}></footer>
      </Host>
    );
  }
}
